import { Header } from "./header";
import { Helpers } from "./helpers/helpers";
import { MobileHelpers } from "./helpers/mobile-helpers";

export class Navigation {
	public readonly navExpandedClass = 'nav-expanded-open';
	constructor(shouldInit = false) {
		this.wrapper = document.querySelector('.wrapper') as HTMLElement;
		this.hamburgerState = document.querySelector('.menu-icon-checkbox') as HTMLFormElement;
		if (shouldInit) {
			this.bindElements();

			if (!Helpers.isEditScreen) {
				this.initiateFixedNav();
			}

		}
	}

	bindElements() {
		//bind hamburger
		const header = new Header();
		this.hamburgerState?.addEventListener('change', () => {
			const input = event.target as HTMLInputElement;
			this.wrapper.classList.toggle(this.navExpandedClass);

			if (this.isExpandedNavigationOpen()) {
				header.closeSearchBox();
			}

			if (!MobileHelpers.isBelowMd()) {
				header.openHeaderSearchBox(false, false);
			}

			if (!input.checked) {
				header.closeSearchBox(true);
			}
		});

		document.querySelectorAll('.sub-navigation a[href^="#"]')?.forEach(anchor => {
			const sectionSelector = anchor.getAttribute('href');
			if (sectionSelector === "#") {
				return;
			}
			const section = document.querySelector(sectionSelector);
			if (!section) {
				anchor.parentElement.classList.add('d-none');
			}
		});

		document.querySelectorAll('a[href^="#"]')?.forEach(anchor => {
			const sectionSelector = anchor.getAttribute('href');
			if (sectionSelector === "#") {
				return;
			}
			const section = document.querySelector(sectionSelector);
			if (section) {
				anchor.addEventListener('click',
					(e) => {
						e.preventDefault();
						const link = e.target as HTMLElement;
						const element = document.querySelector(link.getAttribute("href"));
						let yOffset = -114;

						if (!document.querySelector(".main-header.transparent")) {
							yOffset = yOffset * 2;
						}

						const y = element.getBoundingClientRect().top + yOffset;
						Helpers.scrollTo(y, 1);

					});
			} 
		});

		let resourceNav = document.querySelector('.resource-nav')
		let resourceNavLinks = document.querySelectorAll('.resource-nav a')

		if (!Helpers.isNullOrUndefined(resourceNav)) {
			resourceNav.addEventListener('click', (e) => {
				if (window.innerWidth < 768) {
					resourceNav.classList.toggle('expanded');
				}
			});
		}

		resourceNavLinks?.forEach(anchor => {
			const sectionSelector = anchor.getAttribute('href');
			if (sectionSelector === "#") {
				return;
			}
			const section = document.querySelector(sectionSelector);
			if (section) {
				anchor.addEventListener('click',
					(e) => {
						e.preventDefault();
						resourceNavLinks?.forEach(anchor => {
							anchor.classList.remove('active');
						});

						anchor.classList.add('active');

						const link = e.target as HTMLElement;
						const element = document.querySelector(link.getAttribute("href"));
						let yOffset = -155;

						if (!document.querySelector(".main-header.transparent")) {
							yOffset = yOffset * 2;
						}

						const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
						Helpers.scrollTo(y, 1);

					});
			}
		});

	}

	public isExpandedNavigationOpen(): boolean {
		return this.wrapper.classList.contains(this.navExpandedClass);
	}

	public closeExpandedNavigation() {
		this.wrapper.classList.remove(this.navExpandedClass);
		this.hamburgerState.checked = false;
	}

	private initiateFixedNav() {
		const mainHeader = document.querySelector(".main-header");
		if (window.scrollY > 10) {
			mainHeader?.classList.add('fixed');
		} else {
			mainHeader?.classList.remove('fixed');
		}
		window.addEventListener('scroll',
			() => {
				if (window.scrollY > 10) {
					mainHeader?.classList.add('fixed');
				} else {
					mainHeader?.classList.remove('fixed');
				}
			});
	}

	wrapper: HTMLElement;
	hamburgerState: HTMLFormElement;

	
}